export const SURVEY_DAY_ONE = 'Day 1';
export const SURVEY_WEEK_ONE = 'Week 1';
export const SURVEY_MONTH_ONE = 'Month 1';
export const SURVEY_MONTH_TWO = 'Month 2';
export const SURVEY_MONTH_THREE = 'Month 3';
export const SURVEY_MONTH_FOUR = 'Month 4';
export const SURVEY_MONTH_SIX = 'Month 6';
export const SURVEY_ANNUAL = 'Annual';

const RECOMMEND_ORG = 'Recommend Organization 1-10';
const ORGANIZATION_FOLLOW_UP = 'Organization Followup';
const MOST_HELPFUL_SUPPORT = 'Most Helpful Support';

export function generateCheckInStatusIcon(
  surveyTitle: string,
  partialSubmission: boolean,
  submissions: Record<string, any>): string {
  if (partialSubmission) {
    return 'checkInsStatusDefaultIcon';
  }

  if ([SURVEY_DAY_ONE, SURVEY_WEEK_ONE, SURVEY_MONTH_ONE, SURVEY_MONTH_TWO, SURVEY_MONTH_THREE].includes(surveyTitle)) {
    return validateOrganizationFollowUpQuestion(submissions);
  }

  if (surveyTitle === SURVEY_MONTH_FOUR || surveyTitle === SURVEY_ANNUAL) {
    const statusIcon = validateRecommendOrg(submissions);
    return statusIcon || 'checkInsStatusCompletedIcon';
  }

  if (surveyTitle === SURVEY_MONTH_SIX) {
    const statusIcon = validateMostHelpfulSupport(submissions);
    return statusIcon || 'checkInsStatusCompletedIcon';
  }

  return 'checkInsStatusDefaultIcon';
}

type IssueType = 'MEDICAL' | 'BEHAV' | 'GENERAL' | 'NONE';

export function getMostHelpfulSupportIssueType(value: string): IssueType {
  const text = typeof value === 'string' ? value.trim().toLowerCase() : '';

  if (text.includes('none')) {
    return 'NONE';
  }
  if (text.includes('medical') || text.includes('health')) {
    return 'MEDICAL';
  }
  if (
    text.includes('behavior') ||
    text.includes('training') ||
    text.includes('introducing') ||
    text.includes('to other pets') ||
    text.includes('family members') ||
    text.includes('routine')
  ) {
    return 'BEHAV';
  }
  if (
    text.includes('veterinary') ||
    text.includes('affording') ||
    text.includes('nutrition') ||
    text.includes('feeding') ||
    text.includes('weight') ||
    text.includes('food') ||
    text.includes('supply') ||
    text.includes('housing') ||
    text.includes('landlord') ||
    text.includes('deposit') ||
    text.includes('temporary') ||
    text.includes('foster') ||
    text.includes('adoption') ||
    text.includes('other') ||
    text.includes('general')
  ) {
    return 'GENERAL';
  }

  return 'GENERAL';
}

export function validateMostHelpfulSupport(submission: Record<string, any>): string {
  const value = submission[MOST_HELPFUL_SUPPORT];

  if (!value) {
    return '';
  }

  let items: any[];

  if (Array.isArray(value)) {
    items = value;
  } else if (typeof value === 'string') {
    items = value.split(',');
  } else {
    items = [value];
  }

  if (items.length >= 3 || !!items.find(i => i.includes('A little bit'))) {
    return 'checkInsStatusAllIssueIcon';
  }

  if (items.length === 2) {
    const types = items.map(getMostHelpfulSupportIssueType);
    const hasMedical = types.includes('MEDICAL');
    const hasBehav = types.includes('BEHAV');
    const hasGeneral = types.includes('GENERAL');

    if (hasMedical && hasBehav) {
      return 'checkInsStatusMedBehavIssueIcon';
    }
    if (hasMedical && hasGeneral) {
      return 'checkInsStatusMedGeneralIssueIcon';
    }
    if (hasGeneral && hasBehav) {
      return 'checkInsStatusGeneralBehavIssueIcon';
    }
    if (hasMedical) {
      return 'checkInsStatusMedicalIssueIcon';
    }
    if (hasBehav) {
      return 'checkInsStatusBehavioralIssueIcon';
    }
    if (hasGeneral) {
      return 'checkInsStatusGeneralIssueIcon';
    }
    return '';
  }

  if (items.length === 1) {
    const type = getMostHelpfulSupportIssueType(items[0]);
    if (type === 'NONE') {
      return '';
    }
    if (type === 'MEDICAL') {
      return 'checkInsStatusMedicalIssueIcon';
    }
    if (type === 'BEHAV') {
      return 'checkInsStatusBehavioralIssueIcon';
    }
    if (type === 'GENERAL') {
      return 'checkInsStatusGeneralIssueIcon';
    }
  }

  return '';
}


export function validateRecommendOrg(submission: Record<string, any>): string {
  const value = submission[RECOMMEND_ORG];

  if (!value) {
    return '';
  }

  return Number(value) < 8 ? 'checkInsStatusGeneralIssueIcon' : '';
}

export function validateOrganizationFollowUpQuestion(submission: Record<string, any>): string {
  const value = submission[ORGANIZATION_FOLLOW_UP];

  if (!value) {
    return 'checkInsStatusDefaultIcon';
  }

  if (typeof value === 'string') {
    return value === 'Yes' ? 'checkInsStatusGeneralIssueIcon' : 'checkInsStatusCompletedIcon';
  }

  if (!Array.isArray(value)) {
    return 'checkInsStatusDefaultIcon';
  }

  const normalized = value.map(v => (typeof v === 'string' ? v.trim().toLowerCase() : ''));
  const hasMedical = normalized.includes('medical');
  const hasBehavior = normalized.includes('behavior');
  const hasGeneral = normalized.includes('general');

  if (normalized.length === 3) {
    return 'checkInsStatusAllIssueIcon';
  }

  if (normalized.length === 2) {
    if (hasMedical && hasBehavior) {
      return 'checkInsStatusMedBehavIssueIcon';
    }
    if (hasMedical && hasGeneral) {
      return 'checkInsStatusMedGeneralIssueIcon';
    }
    if (hasBehavior && hasGeneral) {
      return 'checkInsStatusGeneralBehavIssueIcon';
    }
  }

  if (normalized.length === 1) {
    if (normalized.includes('none')) {
      return 'checkInsStatusCompletedIcon';
    }
    if (hasMedical) {
      return 'checkInsStatusMedicalIssueIcon';
    }
    if (hasBehavior) {
      return 'checkInsStatusBehavioralIssueIcon';
    }
    return 'checkInsStatusGeneralIssueIcon';
  }

  return 'checkInsStatusDefaultIcon';
}
